import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import ContributorDetails from './contributorDetails'
import ContributorPaymentsDetail from './ContributorPaymentsDetail'

function ContributorSoldImgContainer() {

  return (
    <MainLayout navTitle={"Contributor Sold Images Payment Details"} navSubTitle={"Welcome to ImagesBazaar"}>
      <ContributorPaymentsDetail/>
    </MainLayout>
  )
}

export default ContributorSoldImgContainer;